import React, { useState, useEffect } from 'react'
import './index.css'
import { Button } from '@material-ui/core'
import { ReactComponent as Alert } from '../../assets/alert.svg'
import { ReactComponent as Close } from '../../assets/close_gray.svg'
import { isMobile } from 'react-device-detect'
import moment from 'moment'
import COLORS from '../../colors'
 
const ModalSendReport = ({ popup, start, end, onClose, onConfirmation }) => {
		const [ width, setWidth ] = useState(window.innerWidth)
		const [ height, setHeight ] = useState(window.innerHeight)

		useEffect(()=>
		{
			function setInnerDimension()
			{
					setWidth(window.innerWidth)
					setHeight(window.innerHeight)	 	 
			}
			window.addEventListener('resize', setInnerDimension, false)
			return () => window.removeEventListener('resize', setInnerDimension, false)
		},[])

	if (!popup) return null
    return (
    			<div className="modal" >
					<div className="overlay-modal" />
					<div className="modal-send-report-body" style={{width:!isMobile?'25rem':'90%', height:!isMobile?(height>820?'21rem':'45%'):'50%'}}>
						<div className="modal-send-report">
							<div className="modal-send-report-title">Jesi li siguran?</div>
							<Close className="modal-send-report-close-btn" onClick={() => onClose()}/>
						</div>
						<Alert />
						{start!==end?
							<div className="modal-send-report-text">
								Sigurno želiš poslati izvještaj transakcija od dana
								{' '} 
								{moment(start).format("DD.MM.YYYY")} <span>do {moment(end).format("DD.MM.YYYY")}</span>
								{' '} 
								na e-mail adresu za izvještaje?
							</div>:
							<div className="modal-send-report--text">
								Sigurno želiš poslati izvještaj za transakciju dana
								{' '}
								{moment(start).format("DD.MM.YYYY")} na e-mail adresu za izvještaje?
							</div>
						}
						<Button size="large" 
                 			variant="contained"
                 			style={{ width:'90%', 
                             	color:"#fff", 
                             	fontWeight: 'bold', 
                             	backgroundColor: COLORS.blue, 
                     		 	textTransform: 'none',
							 	margin:'1rem',
								"&:hover": {
									backgroundColor: COLORS.blue
							  	} 
                       			}} 
							onClick={() => onConfirmation()}
						>POŠALJI IZVJEŠTAJ</Button>
						<Button size="large" 
                 			variant="contained"
                 			style={{ width:'90%', 
                             	color:"#000", 
                             	fontWeight: 'bold', 
                             	backgroundColor:'#fff',
								border: '2px solid #2F2F5B',
								marginBottom: '1rem',  
                     		 	textTransform: 'none',
								  "&:hover": {
									backgroundColor: '#fff'
							  	} 
                       			}} 
							onClick={() => onClose()}
						>ODUSTANI</Button>	
					</div>
    			</div>
	)
}

export default ModalSendReport
